import { v4 as uuidv4 } from 'uuid';
import type { FeaturePermissions, ModuleTemplate, SectionItem, TemplateProperty } from '#layers/studio/app/runtime/types/modules';
import { ModuleTemplateSettings } from '#layers/studio/app/runtime/types/modules';
import {
    setAccess,
    simplePermissions,
    standardPermissions,
    advancedPermissions,
    resetPermissions,
    has,
    checkPermissions,
    translate
} from '#layers/studio/app/runtime/utils/modules';

export function createSection(symbol: string = null, name: string)
{
    const id = uuidv4();

    const section: SectionItem = {
        id: id,
        symbol: symbol || '',
        name: name,
        displayName: {},
        formId: null,
        template: 'Table',
        isHidden: false,
        columns: {
            enabled: undefined,
            visible: {},
            positions: {}
        },
        filters: {
            enabled: undefined,
            visible: {},
            positions: {}
        },
        permissions: [
            {
                items: [
                    { value: '', name: '', scope: 'All' }
                ]
            }
        ],
        features: {
            access: { permissions: [], condition: 'And', type: 'Access' },
            create: { permissions: [], condition: 'And', type: 'Access' },
            view: { permissions: [], condition: 'And', type: 'All' },
            update: { permissions: [], condition: 'And', type: 'All' },
            delete: { permissions: [], condition: 'And', type: 'All' },
            accept: { permissions: [], condition: 'And', type: 'All' },
            manage: { permissions: [], condition: 'And', type: 'All' },
            export: { permissions: [], condition: 'And', type: 'Access' }
        },
        settings: {
            canAdd: true,
            canExport: true,
            editOnModal: false,
            modalSize: 'md',
            scrollableModal: false,
            hasResourcePermissions: false,
            enableFilters: true,
            customisableColumns: true
        }
    };

    simplePermissions(section);

    return section;
}

// Re-eksportuj wszystkie inne funkcje z studio
export {
    setAccess,
    simplePermissions,
    standardPermissions,
    advancedPermissions,
    resetPermissions,
    has,
    checkPermissions,
    translate
};
